const initOffertaAccept = () => {
  const offertaChanger = document.querySelector('[data-offerta]');

  if (offertaChanger) {
    const targetElementSelector = offertaChanger.dataset.offerta;
    const $checkbox = offertaChanger.querySelector('input[type="checkbox"]');

    if (!$checkbox || !targetElementSelector) {
      return;
    }

    $checkbox.addEventListener('change', (e) => {
      const $target = e.currentTarget;
      const $targetElement = document.querySelector(targetElementSelector);

      if ($targetElement) {
        $targetElement.disabled = !($target.checked);
      }
    });
  }
};

export {initOffertaAccept};
